import { render, staticRenderFns } from "./detalleFilters.vue?vue&type=template&id=48edc574"
import script from "./detalleFilters.vue?vue&type=script&lang=js"
export * from "./detalleFilters.vue?vue&type=script&lang=js"
import style0 from "./detalleFilters.vue?vue&type=style&index=0&id=48edc574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports